import { useSelector, useDispatch } from 'react-redux';
import {useEffect, useState} from 'react';
import { CartoLayer, colorBins } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';
import { useAppState } from 'components/contexts/State';

export const TSN_HISTORICAL_SEGMENT_LAYER_ID = 'tsnHistoricalSegmentLayer';

const layerConfig = {
  title: 'VRU Segment Crash Heat Map',
};

function TsnHistoricalSegmentLayer() {
  const dispatch = useDispatch();
  const { tsnHistoricalSegmentLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) => selectSourceById(state, tsnHistoricalSegmentLayer?.source));
  const cartoLayerProps = useCartoLayerProps({ source });
  const viewState = useSelector((state) => state.carto.viewState);
  const pointLineWidth = viewState.zoom >= 7 ? 7 :4;
  let [domainArray, setDomainArray] = useState([1, 25, 75, 150, 200]);
  const {isVRUCrashesFilterActive} = useAppState();




  if (tsnHistoricalSegmentLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: TSN_HISTORICAL_SEGMENT_LAYER_ID,
      geoColumn: 'geom',
      stroked: false,
      filled: true,
      lineWidthMinPixels: pointLineWidth,
      lineWidthMaxPixels: 10,
      pickable: true,
      lineWidthScale: 1,
      visible: tsnHistoricalSegmentLayer.visible,
      opacity: tsnHistoricalSegmentLayer.opacity,

      getLineColor: colorBins({
        attr: 'Crash_Volume',
        domain: domainArray,
        colors: [
          [235, 74, 64, 0],
          [235, 74, 64, 64],
          [235, 74, 64, 128],
          [235, 74, 64, 192],
          [235, 74, 64, 255],
        ],
      }),
      coverage: 0.95,
      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: TSN_HISTORICAL_SEGMENT_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
              //includeColumns: ['h3'],
            }),
          };
        }
      },
    });
  }
}

export default TsnHistoricalSegmentLayer;
